import { userActionSelectors as selector } from "../Selectors/index";
import UserService from "Service/AdminDashboard/Role/role.service";
import AuthService from "../../Service/auth-service";
import { setUserData, checkLoggedIn } from "./authAction";
import { openSnackbar } from "./snackbarActions";

export const getUsers = () => {
  return {
    type: selector.GET_USER,
  };
};

export const getUsersSuccess = (users) => {
  return {
    type: selector.GET_USER_SUCCESS,
    payload: users,
  };
};

export const fetchRole = (val) => {
  return async (dispatch) => {
    // console.log("Dispatching getUsers action");
    dispatch(getUsers());
    try {
      const res =
        val && val !== ""
          ? await UserService.search(val)
          : await UserService.getAll();

      // console.log("API Response:", res); // Log the raw API response
      if (res) {
        // console.log("Fetched Users:", res); // Log the fetched users
        dispatch(getUsersSuccess(res));
      } else {
        console.error("No data received from user API");
      }
    } catch (e) {
      // console.error("Error fetching users:", e);
      dispatch(openSnackbar(true, "error", "Failed to fetch users."));
    }
  };
};